import './force-graph.css';
import OcclusionDetection from './occlusion-detection.js';
import initOption from './init-option.js';
import injectHighlight from './inject-highlight.js';
import globalGraphHelper from './globalGraphHelper.js';
let d3 = window.d3 || null;

let ForceGraph = class {
    constructor(option) {
        console.log('force-graph:', 'new');
        this.init(option);
        // window.__forceGraph = this;
    }

    // 注入配置
    setOption(option) {
        Object.assign(this.option, option);
        return this;
    }

    // 注入实例属性和方法
    inject(obj) {
        Object.assign(this, obj);
        return this;
    }

    // 绑定函数this 箭头函数的写法浏览器原生还不支持
    bindFunction() {
        let bindFuArr = ['ticked', 'dragstarted', 'dragged', 'dragended', 'setLock'];
        bindFuArr.forEach((item) => {
            this[item] = this[item].bind(this);
        });
    }

    init(option) {
        this.option = option;
        globalGraphHelper(this);
        // defalut option
        if (!this.option.scale) { this.option.scale = 1; }
        initOption.call(this, option);
        option.d3 && (d3 = option.d3);

        // 初始化DOM容器
        this.dom = option.dom;
        this.dom.innerHTML = '';
        let { width, height } = this.dom.getBoundingClientRect();
        this.width = width;
        this.height = height;

        // 初始化flag
        this.isStop = false;
        this.isDestroy = false;
        this.isDrag = false;

        // 初始化变量
        this.lockNode = null;
        this.lockTimer = null;
        this.highlightNode = null;

        this.data = option.data;
        this.data = JSON.parse(JSON.stringify(this.data));

        this.bindFunction();

        this.createSvg();
        this.initZoom();

        injectHighlight(this);

        // 自动使用 建议数据处理在这之前做
        if (this.option.auto) {
            this.force();
            this.render();
            this.start(); // 开始运行后link中source和target就会变成对象 而不是ID
            this.light();
        }
    }

    createSvg() {
        this.svgEle = d3.select(this.dom).append('svg').attr('class', 'main-force-graph')
            .attr('width', this.width).attr('height', this.height);
        this.svg = this.svgEle.append('g').attr('class', 'force-graph-svg-main-group');
    }

    render(option = {}) {
        this.setOption(option);
        this.createLinks();
        this.createNodes();
    }

    initZoom() {
        this.zoom = d3.zoom().on('zoom', () => {
            this.svg.attr('transform', d3.event.transform);
        });
        this.svgEle.call(this.zoom);
        this.scaleToSmall = false;
        this.zoom.on('end', () => {
            let scale = d3.event.transform.k;
            if (scale < 0.5 && this.scaleToSmall === false) {
                this.scaleToSmall = true;
                this.option.scaleSmall();
            }
        });
        this.svgEle.on('dblclick.zoom', null); // 禁止双击
        this.zoomTo = (scaleRate = 1, duration = 700) => {
            this.svgEle.transition().duration(duration).call(this.zoom.scaleTo, scaleRate); // this.zoom.scaleBy(this.svgEle, scaleRate);
        };
        this.zoomIn = (scaleRate = 1.2, duration = 700) => {
            this.svgEle.transition().duration(duration).call(this.zoom.scaleBy, scaleRate);
        };
        this.zoomOut = (scaleRate = 0.8, duration = 700) => {
            this.svgEle.transition().duration(duration).call(this.zoom.scaleBy, scaleRate);
        };
        this.translateTo = (width = this.width / 2, height = this.height / 2, duration = 700) => {
            this.svgEle.transition().duration(duration).call(this.zoom.translateTo, width, height);
        };
        this.zoom.scaleTo(this.svgEle, 1);
        this.zoom.translateTo(this.svgEle, this.width / 2, this.height / 2);
        if (this.option.zoom) {
            this.zoom.scaleBy(this.svgEle, this.option.zoom); // TODO 是否要在最后一个
        }

        // 双击解锁
        this.svgEle.on('dblclick', () => {
            let eventTarget = d3.event.target;
            let resetClassList = ['main-force-graph'];
            let isResetFlag = false;
            resetClassList.forEach(_ => eventTarget.classList.contains(_) && (isResetFlag = true)); // 判断是否点击了空白的位置
            if (isResetFlag) {
                this.setLock();
                this.resetHighlight();
                this.lockNode = null;
                this.highlightNode = null;
            }
            // this.data.nodes.forEach(node => {
            //     node.fx = null;
            //     node.fy = null;
            // });
        });
    }

    force(forceObj = {}) {
        this.simulation = d3.forceSimulation();

        // link力
        let _forceLink = d3.forceLink().id(d => d.id || d.index);
        this._forceLink = forceObj.forceLink || _forceLink;
        this.simulation.force('link', this._forceLink);

        // 电荷力
        let _forceCharge = undefined;
        this._forceCharge = forceObj.forceCharge || _forceCharge;
        this.simulation.force('charge', this._forceCharge);

        // 中心力
        let _forceCenter = d3.forceCenter(this.width / 2, this.height / 2);
        this._forceCenter = forceObj.forceCenter || _forceCenter;
        this.simulation.force('center', this._forceCenter);

        // 碰撞半径
        let _forceCollide = d3.forceCollide().radius(30);
        this._forceCollide = forceObj.forceCollide || _forceCollide;
        this.simulation.force('collide', this._forceCollide);

        // x方向力
        let _forceX = undefined;
        this._forceX = forceObj.forceX || _forceX;
        this.simulation.force('x', this._forceX);

        // y方向力
        let _forceY = undefined;
        this._forceY = forceObj.forceY || _forceY;
        this.simulation.force('y', this._forceY);

        // this.simulation.force("steelblue", this.isolate(d3.forceX(width / 6), function(d) { return d.color === "steelblue"; }))

        // let r = this.simulation.alphaTarget();
        // debugger

        return this;
    }

    isolate(force, filter) {
        let nodes = this.data.nodes;
        let dealNodes = nodes.filter(filter);
        let initialize = force.initialize;
        force.initialize = function () { initialize.call(force, dealNodes); };
        return force;
    }

    start() {
        console.log('force-graph:', 'start-tick');
        this.tickNum = 0;
        this.forceStart();
        this.startOD();
        return this;
    }

    forceStart() {
        this.simulation.nodes(this.data.nodes); // 灌入Node数据
        this.simulation.force('link').links(this.data.links); // 灌入Link数据

        // 设置布局函数
        // this.simulation.alpha(0.01);
        // this.simulation.alphaMin(0.01);
        this.simulation.alphaDecay(0.06); // 新加入的参数控制 原来没有 会让布局变快
        // this.simulation.alphaTarget(-0.1);
        this.simulation.on('tick', this.ticked); // 监听tick事件
        return this;
    }

    mergeData(data) {
        let targetNodes = data.nodes || [];
        let targetLinks = data.links || [];

        targetNodes.forEach(node => this.data.nodes.push(node));
        targetLinks.forEach(link => this.data.links.push(link));

        return this.data;
    }

    fixData() {
        this.data.nodes.forEach((item) => {
            // item.fx = item.x;
            // item.fy = item.y;
            // item.vx = 0.01;
            // item.vy = 0.01;
        });
    }

    updateData(data) {
        this.dataProcess(data);
        this.fixData();
        this.mergeData(data);
        // this.data = JSON.parse(JSON.stringify(this.data)); // 不能改变对象的引用

        // 注意data方法之前要干什么
        let nodesUpdate = this.nodesGroup.data(this.data.nodes);
        let nodesEnter = nodesUpdate.enter();

        // 最好能够杜绝updater 还是理论上不能够杜绝呢 看看key的关系
        // nodesUpdate.attr('data-dds', d => {
        //     debugger
        // })

        let nodesEnterRes = nodesEnter
            .append('g')
            .attr('class', d => {
                console.log('enter', d.name);
                return 'kg-force-node-wrap kg-force-node-wrap-opacity';
            })
            .call(d3.drag()
                .on('start', this.dragstarted)
                .on('drag', this.dragged)
                .on('end', this.dragended));
        this.drawNode(nodesEnterRes);
        this.nodesGroup = nodesEnterRes.merge(this.nodesGroup); // 这样子tick才能生效

        // 加入新的边
        let linksUpdate = this.linksGroup.data(this.data.links);
        let linksEnter = linksUpdate.enter();
        let linksEnterRes = linksEnter
            .append('path')
            .attr('class', d => {
                console.log('link', d);
                return 'kg-force-link kg-force-link-opacity';
            });
        this.linksGroup = linksEnterRes.merge(this.linksGroup);

        this.simulation.stop();
        this.simulation.force('link').links(this.data.links); // 灌入Link数据

        this.simulation.force('link', null);
        this.simulation.force('link', this._forceLink, function (d) { return d.clusterId === 1; });

        this.simulation.force('charge', null);
        this.simulation.force('charge', this._forceCharge, function (d) { return d.clusterId === 1; });

        this.simulation.force('collide', null);
        this.simulation.force('collide', this._forceCollide);

        this.simulation.nodes(this.data.nodes); // 不加上这个link就全部都是NaN

        let distance = this.width;
        this.simulation.force("toy0",
            this.isolate(d3.forceX(-distance), d => d.clusterId === 0)
        );
        this.simulation.force("toy",
            this.isolate(d3.forceX(distance), d => d.clusterId === 1)
        );

        this.simulation.alpha(0.1).restart();


        // nodesGroupEnter
        //     .append('g')
        //     .attr('class', d => {
        //         console.log(d.name);
        //         return 'kg-force-node-wrap kg-force-node-wrap-opacity';
        //     })
        //     .call(d3.drag()
        //         .on('start', this.dragstarted)
        //         .on('drag', this.dragged)
        //         .on('end', this.dragended));

        // this.drawLock(enterGroupNodes);
        //
        // let linksGroupEnter = this.linksGroup
        //     .data(newData.links)
        //     .enter();
        // linksGroupEnter
        //     .append('path')
        //     .attr('class', 'kg-force-link kg-force-link-opacity');
        // this.option.drawLinkExtend && this.option.drawLinkExtend(linksGroupEnter);
    }

    ticked() {
        this.option.onTicked && this.option.onTicked(this);
        this.linksGroup
            .attr('x1', d => {
                if (!d.source.x) {
                    debugger
                }
                return d.source.x;
            })
            .attr('y1', d => d.source.y)
            .attr('x2', d => d.target.x)
            .attr('y2', d => d.target.y)
            .attr('d', d => {
                if (!d.target.x || !d.target.y) {
                    debugger
                }
                let dx = d.target.x - d.source.x,
                    dy = d.target.y - d.source.y,
                    dr = Math.sqrt(dx * dx + dy * dy);
                let curve = 'M' + d.source.x + ',' + d.source.y + 'A' + dr + ',' + dr + ' 0 0,1 ' + d.target.x + ',' + d.target.y;
                let straight = `M${d.source.x} ${d.source.y} L${d.target.x} ${d.target.y}`; // 直线
                return curve;
            });

        this.nodesGroup
            .attr('transform', d => {
                if (!d || !d.x) {
                    console.log(this.nodesGroup);
                    console.log(arguments);
                }
                return `translate(${d.x},${d.y})`;
            })
            .attr('cx', d => d.x)
            .attr('cy', d => d.y);

        // 根据 ticknum 的布局情况来决定是否显示所有的子节点
        ++this.tickNum;
        // console.log(this.tickNum);
    }

    createLinks() {
        this.linksGroup = this.svg.append('g')
            .attr('class', 'kg-force-links-group')
            .selectAll('path')
            .data(this.data.links)
            .enter()
            .append('path')
            .attr('class', 'kg-force-link kg-force-link-opacity');

        this.option.drawLinkExtend && this.option.drawLinkExtend(this.linksGroup);
    }

    createNodes() {
        // nodesGroup 是 kg-force-node-wrap的组
        this.nodesGroup = this.svg.append('g')
            .attr('class', 'kg-force-nodes-group')
            .selectAll('g')
            .data(this.data.nodes)
            .enter()
            .append('g')
            .attr('class', 'kg-force-node-wrap kg-force-node-wrap-opacity')

        this.nodesGroup
            .call(d3.drag()
                .on('start', this.dragstarted)
                .on('drag', this.dragged)
                .on('end', this.dragended));

        this.drawLock();
        this.drawNode();
    }

    // 拖拽事件
    dragstarted(d) {
        this.isDrag = true;

        // 外面可以控制是否能够拖拽
        let canDragFlag = true;
        if (this.option.canDrag && this.option.canDrag(d) === false) {
            canDragFlag = false;
        }
        if (!d3.event.active) {
            if (canDragFlag) {
                this.simulation.alphaTarget(0.05).restart(); // 原来是0.1
            }
        }

        d.fx = d.x;
        d.fy = d.y;
    }

    dragged(d) {
        console.log('dragged', d);
        d.fx = d3.event.x;
        d.fy = d3.event.y;
    }

    dragended(d) {
        this.isDrag = false;
        if (!d3.event.active) {
            this.simulation.alphaTarget(0);
        }
        // 释放锁定
        // d.fx = null;
        // d.fy = null;
    }

    drawLock(nodesGraph = this.nodesGroup) {
        // 控制区域的圆
        this.lockGroup = nodesGraph.append('g').attr('class', 'kg-force-node-ctrl-area-group');
        this.lockGroup.append('circle')
            .on('click', d => {
                this.lockNode = d;
                this.svg.selectAll('.kg-force-node-ctrl-area-group').style('display', 'none');
            })
            .attr('class', 'kg-force-node kg-force-node-ctrl')
            .attr('r', 50);
        this.option.lockGroupExtend && this.option.lockGroupExtend(this.lockGroup);
    }

    // 设置和清除锁定
    setLock(d = {}) {
        if (this.svg) {
            this.svg.selectAll('.kg-force-node-ctrl-area-group')
                .style('display', _ => _.id === d.id ? 'block' : 'none');
        }
    }

    drawNode(nodesGroup = this.nodesGroup) {
        let defaultRadius = 15;

        // 光晕的圆
        if (this.option.showHalo) {
            nodesGroup.append('circle')
                .attr('r', d => (d.radius || defaultRadius) + 6)
                .attr('class', 'kg-force-node kg-force-node-bg');
        }

        // 正常的圆
        let color = this.color();
        nodesGroup.append('circle')
            .attr('class', 'kg-force-node kg-force-node-entity')
            .attr('r', d => d.radius || defaultRadius)
            .style('fill', d => color(d.id || d.index || this.random()));

        // 文字内容
        nodesGroup.append('text')
            .attr('class', 'kg-force-text')
            .attr('dx', defaultRadius + 8 + 'px')
            // .attr('dx', 0 + 'px')
            .text(d => d.name);

        this.option.drawNodeExtend && this.option.drawNodeExtend(nodesGroup);
        this.bindNodeEvent(nodesGroup);
    }

    // TODO 注意事件的重复绑定
    bindNodeEvent(nodesGroup = this.nodesGroup) {
        nodesGroup
            .on('mouseenter', d => this.lockNode === null && this.setHighlight(d))
            .on('mouseleave', d => this.lockNode === null && this.resetHighlight(d))
            .on('dblclick', (item, index, array) => {
                this.option.onDblClick(item, index, array);
            })
            .on('click', (item, index, array) => {
                this.option.onClick(item, index, array);
            })
            .on('contextmenu', d => {
                // 右键呼出锁定窗
                d3.event.preventDefault();
                this.setLock(d);
            });
    }

    // 寻找指定跳数的关键节点和变
    findLinkedRoute(d, type = 'source', deepCnt = 1, nodeArr, linkArr) {
        if (!nodeArr) {
            nodeArr = [];
        }
        if (!linkArr) {
            linkArr = [];
        }
        let reMap = { source: 'target', target: 'source' };

        // 递归终止条件
        if (deepCnt <= 0 || !d) {
            return void 0;
        }

        // 寻找与自己关联的节点和边
        let nextNodeArr = [];
        this.data.links.forEach(link => {
            let curNode = link[type];
            let tarNode = link[reMap[type]];
            if (curNode.id === d.id) {
                nextNodeArr.push(tarNode);
                nodeArr.push(tarNode);
                linkArr.push(link);
            }
        });

        // 递归查找下一个想查找的层级
        if (nextNodeArr.length) {
            nextNodeArr.forEach(node => this.findLinkedRoute(node, type, deepCnt - 1, nodeArr, linkArr));
        }

        return { nodes: nodeArr, links: linkArr };
    }

    findSideNode(side = 'left') {
        // left right bottom left
        let domList = [];
        this.nodesGroup.datum(function (item) {
            item.rect = this.getBoundingClientRect();
            domList.push(item);
            return item;
        });
        switch (side) {
            case 'left':
                domList.sort((a, b) => a.rect[side] - b.rect[side]); // 升序
                break;
            case 'top':
                domList.sort((a, b) => a.rect[side] - b.rect[side]); // 升序
                break;
            case 'right':
                domList.sort((a, b) => b.rect[side] - a.rect[side]); // 降序
                break;
            case 'bottom':
                domList.sort((a, b) => b.rect[side] - a.rect[side]); // 降序
                break;
        }
        return domList;
    }

    reset() {
        this.data.nodes.forEach(d => {
            d.fx = null;
            d.fy = null;
        });
        // this.simulation.alphaTarget(0.1).restart(); // 玄学参数alphaTarget Hia~ 原来是0.03
        let duration = 100;
        this.zoomTo(1, duration);
        setTimeout(() => {
            this.translateTo(this.width / 2, this.height / 2, duration);
        }, duration);
    }

    startOD() {
        this.OD = new OcclusionDetection({
            rootElement: this.dom,
            detectionElement: '.kg-force-text',
        }).tick((isObscuredList, allList) => {
            allList.forEach(_ => _.element.classList.remove('kg-force-text-opacity'));
            isObscuredList.forEach(_ => _.element.classList.add('kg-force-text-opacity'));
        });
        this.occIntervalTime = setInterval(() => {
            this.OD.detect();
        }, 2000);
    }

    stopOD() {
        clearInterval(this.occIntervalTime);
        this.OD = null;
    }

    destroy() {
        console.log('force-graph:', 'destroy');
        // TODO 能清除的都去清除
        this.isStop = true;
        this.isDestroy = true;
        this.stopOD();
        this.simulation.stop();
        this.dom.innerHTML = '';

        // 全都弄成null 我看你还老实不老实
        for (let key in this) {
            if (key !== 'destroy') {
                this[key] = null;
            }
        }
    }

    // 以base为基础 radio为百分比的随机数
    random(base = 10, ratio = 0.3) {
        let gap = base * ratio;
        return d3.randomUniform(base - gap, base + gap)();
    }

    color() {
        let colorArr = ['#0EB0ED'];
        if (d3.schemeCategory20) {
            colorArr = d3.schemeCategory20;
        } else if (d3.schemeCategory10) {
            colorArr = d3.schemeCategory10;
        }
        colorArr = d3.shuffle([...colorArr]);
        return d3.scaleOrdinal(colorArr);
    }

    $sleep(t) {
        return new Promise(r => setTimeout(r, t))
    }
};

export default ForceGraph;
